import React from 'react';

const SvgLogo = props => (
  <svg viewBox="0 0 187.2 187.3" {...props}>
    <path d="M63.5 177.3H9.9v-53.5H0v63.4h63.5v-9.9zM9.9 9.9h53.6V0H0v63.5h9.9V9.9zm167.4 53.6h9.9V.1h-63.4V10h53.5v53.5zm0 113.8h-53.5v9.9h63.4v-63.5h-9.9v53.6zM74.6 61.1l46.2 31.5-46.2 33.1V61.1m-10-19v103l73.6-52.8-73.6-50.2z" />
  </svg>
);

export default SvgLogo;
